'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$002499 from "./presto.-Two-Factor-Auth-View$$anon$99.js";
import * as $j_presto$002etypes$0024$002dRole$0024 from "./presto.types$-Role$.js";
import * as $j_presto$002etypes$0024$002dRole$002dCode$0024 from "./presto.types$-Role-Code$.js";
import * as $j_presto$002etypes$0024$002dRole$002dId$0024 from "./presto.types$-Role-Id$.js";
import * as $j_presto$002etypes$0024$002dRole$002dName$0024 from "./presto.types$-Role-Name$.js";
var $p;
/** @constructor */
function $c_Lpresto_TwoFactorAuthView$$anon$98() {
  this.bJc = null;
  this.bJ4 = null;
  this.bJ5 = false;
  this.bJd = null;
  this.bJe = false;
  this.bJh = null;
  this.bJa = null;
  this.bJb = false;
  this.bJ6 = null;
  this.bJ7 = false;
  this.bJ8 = null;
  this.bJ9 = false;
  this.bJf = false;
  this.bJg = false;
  this.bJc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.bJh = "Role";
}
export { $c_Lpresto_TwoFactorAuthView$$anon$98 as $c_Lpresto_TwoFactorAuthView$$anon$98 };
$p = $c_Lpresto_TwoFactorAuthView$$anon$98.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_TwoFactorAuthView$$anon$98;
/** @constructor */
function $h_Lpresto_TwoFactorAuthView$$anon$98() {
}
export { $h_Lpresto_TwoFactorAuthView$$anon$98 as $h_Lpresto_TwoFactorAuthView$$anon$98 };
$h_Lpresto_TwoFactorAuthView$$anon$98.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.bJc;
});
$p.M = (function() {
  if ((!this.bJ5)) {
    this.bJ4 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.bJ5 = true;
  }
  return this.bJ4;
});
$p.O = (function() {
  if ((!this.bJe)) {
    this.bJd = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.bJe = true;
  }
  return this.bJd;
});
$p.E = (function() {
  return this.bJh;
});
$p.t = (function() {
  if ((!this.bJb)) {
    this.bJa = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("id", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("created", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("deleted", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("code", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("name", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())))));
    this.bJb = true;
  }
  return this.bJa;
});
$p.N = (function() {
  if ((!this.bJ7)) {
    this.bJ6 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dRole$002dId$0024.$m_Lpresto_types$RoleId$().nN(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().Z(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$OptionDecoder($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().Z())), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dRole$002dCode$0024.$m_Lpresto_types$RoleCode$().kw(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dRole$002dName$0024.$m_Lpresto_types$RoleName$().nO(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())))));
    this.bJ7 = true;
  }
  return this.bJ6;
});
$p.Q = (function() {
  if ((!this.bJ9)) {
    this.bJ8 = new $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$002499.$c_Lpresto_TwoFactorAuthView$$anon$99();
    this.bJ9 = true;
  }
  return this.bJ8;
});
$p.v = (function() {
  if ((!this.bJg)) {
    this.bJf = false;
    this.bJg = true;
  }
  return this.bJf;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee1056) => ((p) => \u03b4scrutinee1056.nI(p)))($j_presto$002etypes$0024$002dRole$0024.$m_Lpresto_types$Role$())));
});
var $d_Lpresto_TwoFactorAuthView$$anon$98 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_TwoFactorAuthView$$anon$98, "presto.TwoFactorAuthView$$anon$98", ({
  TZ: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_TwoFactorAuthView$$anon$98 as $d_Lpresto_TwoFactorAuthView$$anon$98 };
//# sourceMappingURL=presto.-Two-Factor-Auth-View$$anon$98.js.map
